import { render, staticRenderFns } from "./StockAdjustmentList.vue?vue&type=template&id=04273c75"
import script from "./StockAdjustmentList.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports